import { render, staticRenderFns } from "./ModalTwoFactorAuth.vue?vue&type=template&id=047041e3"
import script from "./ModalTwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./ModalTwoFactorAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports